import { createContext } from 'react'

export type ThemeMode = 'light' | 'dark'

export interface ThemeState {
  readonly theme: ThemeMode
  readonly toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeState | undefined>(undefined)
